import { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Templates.scss';
import vacationIcon from '../../assets/icons/leaveTypes/vacation.svg';
import occasionalLeaveIcon from '../../assets/icons/leaveTypes/occasional-leave.svg';
import sickLeaveIcon from '../../assets/icons/leaveTypes/sick-leave.svg';
import unpaidLeaveIcon from '../../assets/icons/leaveTypes/unpaid-leave.svg';
import childcareExtraIcon from '../../assets/icons/leaveTypes/childcare-extra-leave.svg';
import parentalLeaveIcon from '../../assets/icons/leaveTypes/parental-leave.svg';
import maternityLeaveIcon from '../../assets/icons/leaveTypes/maternity-leave.svg';
import militaryLeaveIcon from '../../assets/icons/leaveTypes/military-leave.svg';
import compensatoryOffIcon from '../../assets/icons/leaveTypes/compensatory-off.svg';
import unexcusedAbsenceIcon from '../../assets/icons/leaveTypes/unexcused-absence.svg';
import unpaidCareLeaveIcon from '../../assets/icons/leaveTypes/unpaid-care-leave.svg';
import forceMajeureIcon from '../../assets/icons/leaveTypes/force-majeure.svg';
import { HelpStore } from '../../store/Help';
import { observer } from 'mobx-react';
import { buildDownloadFile } from '../../utils/functions';
import { UnionLocations } from '../../types';
import { useAnalyticsEventTracker } from '../../analytics/analytics';
import { ApplicationTemplatesStore } from '../../store/ApplicationTemplates';
import { Layout, notification, NotificationType } from '@iba-team/portal-react-components/dist';

interface TemplatesI {
  location: UnionLocations
}

type DataTemplatesIconsT = {
  [k:string]: {name: string, icon: string},
}


export const Templates: FunctionComponent<TemplatesI> = observer((props) => {
  const { location } = props;
  const { t } = useTranslation();
  const { downloadFile } = HelpStore;
  const gaEventTracker = useAnalyticsEventTracker('Help');
  const {fetchDataGrid, dataGrid} = ApplicationTemplatesStore;

  useEffect(()=> {
    fetchDataGrid(location);
  },[]);

  const downloadTemplateForCountry = (url: string, docName: string) => {
    downloadFile(url).then((response) => {
      return response.blob();
    }).then((blob) => buildDownloadFile(blob, docName)).catch(async e => notification.open({title: 'Error', type: NotificationType.ERROR, description: JSON.parse(await e.text()).templateFile, }));};

  const dataTemplatesIcons:DataTemplatesIconsT = {
    vacation : {
      name: t('typesOfHolidays.vacation'),
      icon: vacationIcon
    },
    occasionalLeave: {
      name: t('typesOfHolidays.occasionalLeave'),
      icon: occasionalLeaveIcon
    },
    parentalLeave : {
      name: t('typesOfHolidays.parentalLeave'),
      icon: parentalLeaveIcon
    },
    childcareExtraLeave : {
      name: t('typesOfHolidays.childcareExtraLeave'),
      icon: childcareExtraIcon
    },
    maternityLeave : {
      name: t('typesOfHolidays.maternityLeave'),
      icon: maternityLeaveIcon
    },
    unpaidMaternityLeave : {
      name: t('typesOfHolidays.unpaidMaternityLeave'),
      icon: maternityLeaveIcon
    },
    sickLeave : {
      name: t('typesOfHolidays.sickLeave'),
      icon: sickLeaveIcon
    },
    childcareSickLeave : {
      name: t('typesOfHolidays.childcareSickLeave'),
      icon: sickLeaveIcon
    },
    militaryLeave : {
      name: t('typesOfHolidays.militaryLeave'),
      icon: militaryLeaveIcon
    },
    leaveOnDemand : {
      name: t('typesOfHolidays.leaveOnDemand'),
      icon: vacationIcon
    },
    compensatoryOff : {
      name: t('typesOfHolidays.compensatoryOff'),
      icon: compensatoryOffIcon
    },
    unexcusedAbsence : {
      name: t('typesOfHolidays.unexcusedAbsence'),
      icon: unexcusedAbsenceIcon
    },
    unpaidCareLeave : {
      name: t('typesOfHolidays.unpaidCareLeave'),
      icon: unpaidCareLeaveIcon,
    },
    forceMajeure : {
      name: t('typesOfHolidays.forceMajeure'),
      icon: forceMajeureIcon,
    },
  };

  const chooseIcon = (value:string) => {
    for(const key in dataTemplatesIcons) {
      if(value.includes(dataTemplatesIcons[key].name)){
        return dataTemplatesIcons[key].icon;
      }
    }
    return unpaidLeaveIcon;
  };

  return (
    <>
      <Layout className='templates' header={{layoutName:  t('templates')}}>
        <div style={{marginTop: '16px'}}>
          {dataGrid.filter(i => i.ref !== null).map(i =>
            <div className='templates-item'>
              <img src={chooseIcon(i.requestTypeForCountryName)} alt={'icon'}/>
              <div className='templates-item__link' onClick={()=> {
                downloadTemplateForCountry(i.ref || '', i.fileName || '');
                gaEventTracker('download_template', i.fileName || '');
              }}>{ i.fileName }</div>
            </div>
          )}
        </div>
      </Layout>
    </>
  );
});
